//This should be removed , it's a dup now for unit test :-(
//Import from ui-internal can't be resolved for unit test

export default function getSpanOptions(host) {
	return {
		attributes: {
			tagName: host.tagName?.toLowerCase(),
			componentId: host.nowId
		}
	};
}
